import * as React from "react";
import { SvgIcon, SvgIconProps, makeStyles, Theme } from "@material-ui/core";

type Props = styleProps & SvgIconProps;

type styleProps = {
  fillColor?: React.CSSProperties["color"];
};

const useStyles = makeStyles<Theme, styleProps>((theme: Theme) => ({
  root: ({ fillColor }) => ({
    "& .fil0": { fill: fillColor || "#00AD6C" },
  }),
}));

function WMLogo({ fillColor, ...props }: Props) {
  const c = useStyles({ fillColor });

  return (
    <SvgIcon className={c.root} {...props} viewBox="0 0 7367 1478">
      {/* <title>WM Logo</title> */}
      <g id="Camada_x0020_1">
        <metadata id="CorelCorpID_0Corel-Layer" />
        <path
          className="fil0"
          d="M6771 793l-28 172c-11,70 -11,157 -15,234l-4 2 -99 -409 -161 1 -93 583 -15 94 15 0 146 -1 32 -199c10,-63 12,-126 18,-189l2 -3 76 391 195 1 110 -677 -179 0z"
        />
        <polygon
          className="fil0"
          points="6386,792 6371,792 6200,792 6117,1311 6092,1469 6117,1469 6279,1469 6371,887 "
        />
        <polygon
          className="fil0"
          points="6117,952 6142,793 6117,793 5748,793 5722,958 5825,958 5741,1470 5927,1470 6010,958 6116,958 "
        />
        <path
          className="fil0"
          d="M5500 1020c-3,28 -25,60 -51,76 -12,9 -27,13 -39,11l-12 -1 27 -167c9,0 17,0 24,1 35,6 55,33 51,80zm-51 -226c-3,0 -5,-1 -7,-1l-180 0 -108 677 186 0 30 -181c5,-32 8,-66 12,-99l2 -1 58 281 7 0 194 0 -93 -281c79,-30 125,-101 134,-171 23,-173 -84,-223 -235,-224z"
        />
        <path
          className="fil0"
          d="M4940 1082l-5 158 -33 0 -45 0 44 -142 6 -16c14,-43 26,-85 39,-127l1 0c-3,42 -7,92 -7,127zm-39 -289l-39 0 -264 655 -9 22 9 0 182 0 30 -87 92 0 32 0 0 87 192 0 -38 -677 -187 0z"
        />
        <path
          className="fil0"
          d="M4607 793l-9 0 -221 0 -81 235c-11,36 -26,83 -39,126l-1 0 4 -361 -230 0 -190 677 199 0 60 -275c11,-51 18,-99 26,-150l3 0 -4 425 152 0 97 -277c18,-50 32,-99 47,-148l3 0 -52 425 194 0 33 -529 9 -148z"
        />
        <g id="_1928297315296">
          <polygon
            className="fil0"
            points="6014,528 5989,679 6014,679 6335,679 6360,520 6201,520 6217,417 6360,417 6386,256 6243,256 6258,162 6418,162 6443,2 6098,2 "
          />
          <polygon
            className="fil0"
            points="6014,155 6038,2 6014,2 5645,1 5618,167 5719,168 5625,679 5823,679 5905,168 6012,167 "
          />
          <polygon className="fil0" points="5311,585 5296,679 5311,679 5481,679 5590,2 5404,2 " />
          <polygon
            className="fil0"
            points="5325,2 5311,2 5139,2 5101,245 5011,245 5050,2 4864,2 4792,456 4756,679 4792,679 4942,679 4986,405 5074,405 5030,679 5215,679 5311,90 "
          />
          <path
            className="fil0"
            d="M4826 2l-34 0 -147 0 -85 273c-14,49 -27,106 -39,149l-2 0c1,-50 2,-99 2,-149l-3 -273 -160 0 -91 273c-16,47 -27,100 -41,151l-1 0c1,-51 5,-100 5,-151l2 -273 -183 0 45 678 180 -1 84 -274c17,-55 26,-103 38,-150l2 0c-1,47 -5,100 -4,150l6 274 179 0 213 -582 34 -95z"
          />
        </g>
        <path
          className="fil0"
          d="M7217 944c37,0 80,30 114,37l36 -148c-43,-21 -105,-42 -159,-42 -67,0 -125,21 -163,57 -36,37 -56,96 -56,152 0,61 38,116 76,150 26,22 76,61 76,108 0,45 -28,57 -67,57 -33,0 -121,-37 -142,-57l-19 180c46,25 108,37 161,37 76,0 144,-19 181,-56 37,-37 67,-95 67,-171 0,-80 -45,-120 -96,-171 -20,-23 -57,-50 -57,-86 0,-34 13,-47 48,-47z"
        />
        <g id="_1928297320448">
          <path
            className="fil0"
            d="M492 1276c-28,4 -111,68 -111,68 0,0 79,32 119,23 35,-7 115,-67 115,-67 0,0 -82,-29 -123,-24z"
          />
          <path
            className="fil0"
            d="M552 999c-29,4 -111,67 -111,67 0,0 78,33 118,24 35,-7 115,-67 115,-67 0,0 -81,-29 -122,-24z"
          />
          <path
            className="fil0"
            d="M611 721c-28,3 -110,67 -110,67 0,0 78,32 118,24 35,-8 115,-68 115,-68 0,0 -81,-29 -123,-23z"
          />
          <path
            className="fil0"
            d="M682 532c35,-8 115,-68 115,-68 0,0 -82,-29 -123,-23 -28,3 -111,67 -111,67 0,0 79,32 119,24z"
          />
          <path
            className="fil0"
            d="M742 255c34,-8 115,-68 115,-68 0,0 -82,-29 -123,-24 -29,4 -111,68 -111,68 0,0 79,32 119,24z"
          />
          <path
            className="fil0"
            d="M398 95c26,-6 86,-50 86,-50 0,0 -61,-22 -92,-18 -21,3 -83,50 -83,50 0,0 59,25 89,18z"
          />
          <path
            className="fil0"
            d="M335 371c26,-5 86,-50 86,-50 0,0 -61,-22 -92,-18 -21,3 -83,50 -83,50 0,0 59,25 89,18z"
          />
          <path
            className="fil0"
            d="M269 581c-21,3 -83,51 -83,51 0,0 59,24 89,18 26,-6 86,-51 86,-51 0,0 -61,-22 -92,-18z"
          />
          <path
            className="fil0"
            d="M206 855c-21,2 -83,50 -83,50 0,0 59,24 89,18 26,-6 86,-51 86,-51 0,0 -61,-22 -92,-17z"
          />
          <path
            className="fil0"
            d="M147 1132c-22,3 -84,50 -84,50 0,0 59,25 89,18 26,-5 87,-50 87,-50 0,0 -62,-22 -92,-18z"
          />
          <path
            className="fil0"
            d="M83 1409c-21,3 -83,51 -83,51 0,0 59,24 89,17 26,-5 86,-50 86,-50 0,0 -61,-22 -92,-18z"
          />
          <path
            className="fil0"
            d="M879 1356c-37,5 -144,88 -144,88 0,0 102,42 154,31 45,-10 150,-88 150,-88 0,0 -106,-38 -160,-31z"
          />
          <path
            className="fil0"
            d="M938 1083c-36,5 -144,88 -144,88 0,0 103,42 155,31 45,-10 149,-88 149,-88 0,0 -106,-38 -160,-31z"
          />
          <path
            className="fil0"
            d="M998 814c-37,5 -144,87 -144,87 0,0 102,42 154,31 45,-9 150,-87 150,-87 0,0 -107,-38 -160,-31z"
          />
          <path
            className="fil0"
            d="M1068 663c45,-10 149,-88 149,-88 0,0 -106,-38 -160,-31 -37,5 -144,88 -144,88 0,0 103,42 155,31z"
          />
          <path
            className="fil0"
            d="M1123 394c45,-10 149,-88 149,-88 0,0 -106,-38 -159,-31 -37,5 -144,88 -144,88 0,0 102,42 154,31z"
          />
          <path
            className="fil0"
            d="M1182 120c45,-9 150,-87 150,-87 0,0 -106,-38 -160,-31 -37,5 -144,87 -144,87 0,0 102,42 154,31z"
          />
          <path
            className="fil0"
            d="M1533 276c54,-11 179,-105 179,-105 0,0 -127,-45 -191,-37 -45,6 -174,105 -174,105 0,0 123,51 186,37z"
          />
          <path
            className="fil0"
            d="M1453 408c-44,5 -173,105 -173,105 0,0 123,50 186,37 53,-12 179,-105 179,-105 0,0 -128,-46 -192,-37z"
          />
          <path
            className="fil0"
            d="M1402 827c54,-12 179,-105 179,-105 0,0 -127,-46 -191,-37 -44,6 -173,105 -173,105 0,0 123,50 185,37z"
          />
          <path
            className="fil0"
            d="M1331 1100c54,-11 179,-105 179,-105 0,0 -127,-46 -191,-37 -45,6 -174,105 -174,105 0,0 123,51 186,37z"
          />
          <path
            className="fil0"
            d="M1255 1235c-44,6 -173,105 -173,105 0,0 123,51 186,37 53,-11 179,-105 179,-105 0,0 -128,-45 -192,-37z"
          />
          <path
            className="fil0"
            d="M1704 1249c63,-14 210,-123 210,-123 0,0 -149,-54 -224,-44 -52,7 -202,123 -202,123 0,0 143,60 216,44z"
          />
          <path
            className="fil0"
            d="M1757 809c-52,7 -202,123 -202,123 0,0 144,59 217,43 63,-13 209,-122 209,-122 0,0 -149,-54 -224,-44z"
          />
          <path
            className="fil0"
            d="M1623 1360c-40,5 -136,73 -180,106l312 0c49,-31 92,-63 92,-63 0,0 -149,-53 -224,-43z"
          />
          <path
            className="fil0"
            d="M1843 702c63,-13 210,-123 210,-123 0,0 -149,-53 -224,-43 -52,7 -203,123 -203,123 0,0 144,59 217,43z"
          />
          <path
            className="fil0"
            d="M1910 425c63,-14 210,-123 210,-123 0,0 -149,-53 -224,-43 -52,7 -202,123 -202,123 0,0 143,59 216,43z"
          />
          <path
            className="fil0"
            d="M1978 148c63,-14 209,-123 209,-123 0,0 -34,-12 -78,-24l-198 -1c-64,35 -150,104 -150,104 0,0 144,59 217,44z"
          />
          <path
            className="fil0"
            d="M2047 1208c-59,8 -231,140 -231,140 0,0 164,67 247,49 72,-15 239,-140 239,-140 0,0 -170,-61 -255,-49z"
          />
          <path
            className="fil0"
            d="M2135 1124c71,-16 239,-140 239,-140 0,0 -170,-61 -256,-50 -59,8 -231,140 -231,140 0,0 164,68 248,50z"
          />
          <path
            className="fil0"
            d="M2185 661c-59,8 -230,140 -230,140 0,0 164,67 247,50 72,-16 239,-141 239,-141 0,0 -170,-61 -256,-49z"
          />
          <path
            className="fil0"
            d="M2253 388c-59,8 -231,140 -231,140 0,0 164,67 247,49 72,-15 239,-140 239,-140 0,0 -170,-61 -255,-49z"
          />
          <path
            className="fil0"
            d="M2337 304c71,-16 239,-140 239,-140 0,0 -170,-61 -256,-50 -59,8 -231,140 -231,140 0,0 164,68 248,50z"
          />
          <path
            className="fil0"
            d="M2756 171c79,-17 263,-154 263,-154 0,0 -22,-7 -54,-17l-312 0c-77,46 -169,117 -169,117 0,0 181,74 272,54z"
          />
          <path
            className="fil0"
            d="M3849 1l-474 -1c-71,48 -134,96 -134,96 0,0 3,1 9,4 -51,-11 -104,-18 -143,-13 -65,9 -243,142 -276,167 -55,-13 -117,-24 -160,-18 -65,8 -254,154 -254,154 0,0 180,74 272,54 68,-14 213,-118 253,-146 62,17 135,31 185,21 81,-18 258,-146 288,-168 54,12 111,19 152,10 43,-9 111,-47 173,-87l-12 74 -92 58c-54,-11 -109,-18 -150,-13 -71,10 -265,155 -299,181 -52,-11 -107,-19 -147,-14 -65,9 -244,143 -277,168 -55,-14 -117,-25 -160,-19 -65,9 -253,154 -253,154 0,0 180,74 272,55 68,-15 213,-119 252,-147 62,17 136,32 186,21 75,-16 237,-131 281,-163 58,15 122,24 167,14 46,-10 121,-53 187,-96l-10 58 -119 78c-53,-11 -107,-18 -147,-12 -68,9 -249,143 -294,177 -53,-12 -108,-20 -148,-14 -67,9 -248,145 -278,168 -56,-14 -119,-26 -163,-20 -65,9 -254,154 -254,154 0,0 181,75 272,55 69,-15 216,-120 254,-148 63,18 138,33 189,22 72,-15 225,-123 275,-159 59,15 123,24 169,15 52,-12 142,-66 212,-113l-8 54 -143 95c-54,-12 -110,-19 -150,-13 -71,9 -262,152 -299,180 -51,-11 -105,-18 -144,-13 -62,8 -229,131 -271,163 -56,-13 -118,-24 -161,-18 -65,8 -254,154 -254,154 0,0 180,74 272,54 65,-14 202,-110 247,-143 63,18 137,32 187,21 75,-16 234,-129 280,-162 58,14 120,23 164,14 60,-13 168,-82 241,-132l-9 54 -177 116c-51,-10 -102,-16 -140,-11 -68,9 -252,145 -295,178 -54,-12 -110,-20 -151,-15 -66,9 -248,145 -278,168 -55,-14 -119,-25 -163,-19 -50,7 -173,93 -227,133l394 0c46,-30 88,-59 105,-72 63,18 138,33 189,22 73,-16 227,-125 276,-160 60,15 126,25 172,15 66,-14 192,-98 263,-147l-7 57 -198 129c-53,-10 -107,-17 -147,-12 -63,9 -224,125 -282,169l470 -1c48,-30 92,-61 120,-81l-7 46 -4 0 0 4 -4 0 -4 4 -43 27 301 0 233 -1465 -153 0c0,0 1,0 1,0z"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default WMLogo;
